import { CssVarsProvider } from "@mui/joy/styles";

import { theme } from "../theme";

export default function ThemeProvider({ children }: { children: React.ReactNode }) {
    return (
        <CssVarsProvider theme={theme} defaultMode="light" modeStorageKey="joy-mode">
            {children}
        </CssVarsProvider>
    );
}
